import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { getSelectedCourse } from '../../store/courses/selectors';
import { ICourse, IOrganiserProfile, ICPDPoints, ITrainerProfile, IConcentration } from '../../store/interface';
import queryString from 'query-string'
// @ts-ignore
import { store } from 'react-notifications-component';
import DetailForm from './detailForm';

import { listRequest as listRequestAction,
    createRequest as createRequestAction,
    updateRequest as updateRequestAction,
    deleteRequest as deleteRequestAction,
    selectData as selectDataAction, 
    selectedData as selectedAction,
    selectedClear as selectedClearAction
} from '../../store/courses/actions';
// Organisers
import { getOrganisers } from '../../store/organisers/selectors';
import { listRequest as listRequestOrganisersAction, listClear as listClearOrganisersAction} from '../../store/organisers/actions'
// Concentrations
import { getConcentrations } from '../../store/concentrations/selectors';
import { listRequest as listRequestConcentrationsAction, listClear as listClearConcentrationsAction} from '../../store/concentrations/actions'

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    data: any
    ui : any
    dataOrganiser: any
    dataConcentration: any
}

interface IState {
    isNew: boolean
    newCourseId : string
    modalOverwriteWarning: boolean
    uploadProgress:number
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest : typeof listRequestAction 
    createRequest : typeof createRequestAction
    updateRequest : typeof updateRequestAction
    deleteRequest : typeof deleteRequestAction
    selectData : typeof selectDataAction
    selectedData : typeof selectedAction
    selectedClear : typeof selectedClearAction
    listRequestOrganiser : typeof listRequestOrganisersAction
    listClearOrganiser : typeof listClearOrganisersAction
    listRequestConcentrations : typeof listRequestConcentrationsAction
    listClearConcentrations : typeof listClearConcentrationsAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class CourseDetailPage extends React.Component<AllProps, IState> {
    constructor(props: AllProps) {
        super(props);
        this.state = {
            modalOverwriteWarning : false,
            isNew : false,
            newCourseId : '',
            uploadProgress: 0
        };
        this.readData = this.readData.bind(this);
        this.createOrUpdateData = this.createOrUpdateData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.handleOverwriteWarning = this.handleOverwriteWarning.bind(this);
    }

    public componentDidMount() {
        let id = this.props.route.match.params.id;
        if (id.toUpperCase() === "NEW"){
            this.setState({isNew: true, newCourseId : this.generateCourseId(6)});
        }else{
            this.props.selectData(id);
        }

        if (this.props.dataOrganiser.length === 0) {
            var searchParams:any = {};
            searchParams["term"] = "";
            searchParams["sorting"] = "";
            searchParams["offset"] = 0;
            searchParams["limit"] = 100;
            this.props.listRequestOrganiser(searchParams);
        }
        
        if (this.props.dataConcentration.length === 0) {
            var searchParams:any = {};
            searchParams["term"] = "";
            searchParams["sorting"] = "";
            searchParams["offset"] = 0;
            searchParams["limit"] = 100;
            this.props.listRequestConcentrations(searchParams);
        }
    }
    public componentWillUnmount() {
        this.props.selectedClear();  
    } 

    generateCourseId(length:number) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    readData(){
        const parsed = queryString.parse(this.props.route.location.search);
        var searchParams: any = {};
        searchParams["id"] = this.props.ui.selected;
        searchParams["pk"] = Number(parsed.pk);
        searchParams["period"] = Number(parsed.pk);
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        this.props.listRequest(searchParams);
    }

    componentDidUpdate(prevProps: AllProps) {
        //console.log("componentDidUpdate : " + this.props.ui.selected);
        // Load data if direct access from link
        if (prevProps.ui.selected === undefined && this.props.ui.selected != undefined && this.props.data === undefined){
            this.readData();
        }

        // Load data to state for chanages
        if ((this.props.ui.processState !== 3) && (
            (prevProps.data === undefined && this.props.data !== undefined) || 
            //(this.props.ui?.selected !== "")
            (prevProps.data?.id !== this.props.data?.id)
            )){

            this.props.selectedData();
        }

       

        // Show notification
        if ((prevProps.data?._etag != this.props.data?._etag) || 
            (prevProps.ui.processState != this.props.ui.processState) ){
            let notification = { show : false, title:"", type: "", message : "" };

            if (this.props.ui.processState === 1){ // Create/Update success
                if (this.state.isNew){ // Added successfully
                    this.setState({isNew: false});
                    this.props.route.history.push('/courses/' + this.props.ui.selected + "?pk=" + this.props.data.period);
                }
                notification.show = true;
                notification.type = "success";
                notification.message = "Save successfully";
                
            } else if (this.props.ui.processState === 2){ // Create/Update failed
                if (this.props.ui.isConflict){
                    this.setState({ modalOverwriteWarning : true});
                } else {
                    this.setState({ modalOverwriteWarning : false});

                    notification.show = true;
                    notification.type = "danger";
                    notification.message =  "Process failed. Error : \n" + this.props.ui.errors;
                }
            } else if (this.props.ui.processState === 3){ // Delete success
                // Show custom dialaog box
            } else if (this.props.ui.processState === 4){ // Delete failed
                notification.show = true;
                notification.type = "danger";
                notification.message =  "Delete failed. Error : \n" + this.props.ui.errors;
            }

            if (notification.show){
                store.addNotification({
                    title: notification?.title ?? "Info",
                    message: notification.message,
                    type: notification.type,
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                }); 
            }
        }
    }
    
    handleSelectValue = (selectedValue: any) => {
        let val: any = []
        if(selectedValue) {
            selectedValue.forEach((element:any) => {
                val.push(element.label);
            });
        }
        return val;
    }
    handleCountrySelectValue = (selectedValue: any) => {
        let val: any = []
        if(selectedValue) {
            //console.log(selectedValue)
            selectedValue.forEach((element:any) => {
                //val.push(element.label);
                val.push(element.value); // Store country code instead of name
            });
        }
        return val;
    }
   
    createOrUpdateData = async (formData:any) => {
        //console.log("createOrUpdate:" + JSON.stringify(data));
        //console.log("createOrUpdate:" + overwrite);

        let discountCodeArray:string[] = [];
        if (formData.discountCode){
            formData.discountCode.map((i:any)=>{
                discountCodeArray.push(i.value);
            })
        }

        if (this.state.isNew){
            const orgProfile : IOrganiserProfile = {
                id : "",         
                oId : "",             
                orgName : "",        
                orgProfile : "",    
                orgProfileImgURL :"", 
                orgEmail: "",
                orgPhoneNo: "",
                orgAddress : "",
                orgProfession : [],
                contactPersonName : "",        
                contactPersonTitle : "",       
                contactPersonPhone : "",  
                contactPersonWorkPhone : "",    
                contactPersonEmail : "",      
                trainers : [],
                searchKeywords: ""
            }
            const cpdPoints : ICPDPoints = {
                profession : "",         // Profession Name. Choose profession
                points : 0,             // CPD Hour/Points. Number
                cpdRefNo : "",           // CPD Reference Number. String entry
                cpdDesc : "",
                cpdIssuerName : "",
                cpdVerification : true,
                cpdExpiry : ""
            }

            const trainer: ITrainerProfile = {
                id : "",
                organiserId : "",
                name : "",
                profile : "",
                profileImgURL : "",
                profession : [],
                searchKeywords : ""
            }
            const conc : IConcentration = {
                id : 1,
                duration : [0],
                AnswerSpot : 0
            }
            const n:ICourse ={
                id : "",                                        // Unique identifier (Backend)
                courseId : formData.courseId,                   // Course ID internal use
                referenceNumber: formData.referenceNumber,      // Course Internal Reference Number (Modifiable by admin, e.g. Certification serial number using this, admin can change every year / or define a format for it)
                type : "Course",                                // "Course"
                version: 1,                                     // Schema version number
                professionList: this.handleSelectValue(formData.professionList),                             // Profession list. Multi seletion
                countryList: this.handleCountrySelectValue(formData.countryList),                                // Course country lits. Multi seletion
                languages: this.handleSelectValue(formData.languages),                                  // Course languages. Multi seletion
                subtitle : this.handleSelectValue(formData.subtitle),
                period: new Date().getFullYear(),               // Partition key, year of course
                courseStatus : formData.courseStatus,                              // Course Status, temporary not in use, based on expiry date
                title: formData.title,                          // Course Title. Single Line
                titleLowercase : formData.title.toLowerCase(),  // Title lowercase for sorting purpose
                shortDesc : formData.shortDesc,                                 // Short description. Multile line 2 line only
                longDesc : formData.longDesc,                                  // Long description. Multile line 5 line only
                objective : formData.objective,                                 // Course objective. Multile line 5 line only
                programOutline : JSON.parse(formData.programOutline),                            // Course featres. Array of string
                courseFeatures : JSON.parse(formData.courseFeatures),                            // Course featres. Array of string
                qualification : formData.qualification,                             // Qualificaiton. Multile line 5 line only
                requirement : formData.requirement,                               // Requirements. Multile line 5 line only
                termsAndConditions : formData.termsAndConditions,                        // Terms and conditons. Multile line 5 line only
                agenda : formData.agenda,                                    // Course Agenda. Multile line 5 line only
                methodology : formData.methodology,                               // Course Methodology. Multile line 5 line only
                publishedDT : new Date(),                       // Publish Date. Date
                expiryDT : new Date(),                          // Expiry Date. Calc backend publishedDT + courseShelfLifeDays
                videoURL : formData.videoURL,                                  // Video URL (MP4) . File Upload
                videoThumbnailURL : formData.videoThumbnailURL,                         // Video Image URL (Thumbnail) . File Upload
                courseFlyerURL : formData.courseFlyerURL,
                courseCPDPointURL : formData.courseCPDPointInfoURL,
                uploadDT : new Date(),                          // Upload Date Time. Backend
                cpdPoints : JSON.parse(formData.cpdPoints),                        // Array of CPDPoints
                duration : formData.duration,                                   // Course duration.Number in [] seconds
                currency : formData.currency,
                normalPrice : formData.normalPrice,                                // Course Normal Price . Double [] in RM
                memberPrice: formData.memberPrice,                                 // Course Member Price. Double [] in RM
                discountCode : discountCodeArray,
                discountPrice :formData.discountPrice,                               // Course Discounted Price. Double [] in RM
                priceAdjNoVerification : formData.priceAdjNoVerification,
                slidesFileURL : "",                             // Slides File URL. File Upload
                courseShelfLifeDays : formData.courseShelfLifeDays,                        // Life time course display on market place. Number entry []Days
                userShelfLifeDays : formData.userShelfLifeDays,                          // Life time user can playback.  Number entry []Days
                organiser : JSON.parse(formData.organiser),                         // Organizer Profile
                trainerFAQFileURL : "",                         // Trainer FAQ. File Upload
                trainerProfile : [trainer],                     // Trainer Profile
                certificateId : "",                             // Certificate Template ID to use
                concentrationId : formData.concentrationId?.value,     // Concentration Template ID to use
                concentrationDurationSettingsJSON : JSON.parse(formData.concentrationDurationSettingsJSON),     // Concentration settings
                verification : (formData.verification || formData.verification == "true")? true : false,
                noVerification : (formData.noVerification || formData.noVerification == "true")? true : false,
                noTracking : (formData.noTracking || formData.noTracking == "true")? true : false,
                createdDT : new Date(),                         // Course created on. Backend
                createdBy : "",                                 // Course created by. Backend
                lastEdited : new Date(),                        // Course last edited time. Backend
                lastEditBy : "",                                // Course last edited by who. Backend
                searchKeywords : "",                            // List of keywords for search. Backend
            };

            this.props.createRequest(n);
        } else {
            let overwriteFlag = formData.Overwrite === "true"? true:false;
            this.props.updateRequest({
                id : this.props.ui.selected,
                period : this.props.data.period,
                courseId : this.props.data.courseId,
                title : formData.title,
                titleLowercase : formData.title.toLowerCase(),
                referenceNumber : formData.referenceNumber,
                professionList : this.handleSelectValue(formData.professionList),
                countryList : this.handleCountrySelectValue(formData.countryList),
                languages : this.handleSelectValue(formData.languages),
                subtitle : this.handleSelectValue(formData.subtitle),
                shortDesc : formData.shortDesc,
                longDesc : formData.longDesc,
                objective : formData.objective,
                programOutline : JSON.parse(formData.programOutline),
                courseFeatures : JSON.parse(formData.courseFeatures), 
                qualification : formData.qualification,
                requirement : formData.requirement,
                termsAndConditions : formData.termsAndConditions,
                agenda : formData.agenda,
                methodology : formData.methodology,
                cpdPoints : JSON.parse(formData.cpdPoints),
                duration : formData.duration,
                currency : formData.currency,
                normalPrice : formData.normalPrice,
                memberPrice : formData.memberPrice,
                discountCode : discountCodeArray,
                discountPrice : formData.discountPrice,
                priceAdjNoVerification : formData.priceAdjNoVerification,
                courseShelfLifeDays : formData.courseShelfLifeDays,
                userShelfLifeDays : formData.userShelfLifeDays,
                publishedDT : formData.publishedDT,
                expiryDT : formData.expiryDT,
                courseStatus : formData.courseStatus,
                concentrationId: formData.concentrationId?.value,
                concentrationDurationSettingsJSON: JSON.parse(formData.concentrationDurationSettingsJSON),
                verification : (formData.verification || formData.verification == "true")? true : false,
                noVerification : (formData.noVerification || formData.noVerification == "true")? true : false,
                noTracking : (formData.noTracking || formData.noTracking == "true")? true : false,
                organiser : JSON.parse(formData.organiser),
                trainerProfile : JSON.parse(formData.trainerProfile),
                trainerFAQFileURL : formData.trainerFAQFileURL,
                slidesFileURL : formData.slidesFileURL,
                videoURL : formData.videoURL,
                videoThumbnailURL : formData.videoThumbnailURL,
                courseFlyerURL : formData.courseFlyerURL,
                courseCPDPointURL : formData.courseCPDPointInfoURL,
                overwrite : overwriteFlag,
                _etag : this.props.data._etag,
            });

            if (overwriteFlag === true){
                this.handleOverwriteWarning(); // Trigger close warning modal dialog
            }
        }
    }

    deleteData = async (doc:ICourse) => {
        this.props.deleteRequest(doc);
    }
    
    handleOverwriteWarning(){
        this.setState({modalOverwriteWarning : !this.state.modalOverwriteWarning});
    }

    public render() {
        return (
            <div className="bg-light container">
                {this.props.ui.loading ? 
                    (
                        <div>Loading data&nbsp;<Spinner color="warning">Loading</Spinner></div>
                    )
                    :
                    (
                        <DetailForm 
                            props = {this.props} 
                            read = {this.readData}
                            save = {this.createOrUpdateData}
                            remove = {this.deleteData}
                            overwriteWarningFlag = {this.state.modalOverwriteWarning}
                            overwriteHandleWarning = {this.handleOverwriteWarning}
                            isNew = {this.state.isNew}
                            newCourseId =  {this.state.newCourseId}
                            uploadProgress = {this.state.uploadProgress}
                        />
                    )
                }
                
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.course.ui,
    data: getSelectedCourse(state),
    dataOrganiser: getOrganisers(state),
    dataConcentration: getConcentrations(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest : listRequestAction,
    createRequest : createRequestAction,
    updateRequest : updateRequestAction,
    deleteRequest : deleteRequestAction,
    selectData : selectDataAction,
    selectedData : selectedAction,
    selectedClear : selectedClearAction,
    listRequestOrganiser : listRequestOrganisersAction,
    listClearOrganiser : listClearOrganisersAction,
    listRequestConcentrations : listRequestConcentrationsAction,
    listClearConcentrations : listClearConcentrationsAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CourseDetailPage)
